/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { createAction } from '@modules/app/createAction';

import {
    WIZARD_ORDER_TEMPLATE_HANDLE_NEXT,
    WIZARD_ORDER_TEMPLATE_SET_PARAMS,
    WIZARD_ORDER_TEMPLATE_SET_STEP_VALID,
} from './constants';
import {
    IWizardOrderTemplateSetStepValidPayload,
    TWizardOrderTemplateDataSetParamsAction,
    TWizardOrderTemplateHandleNextAction,
    TWizardOrderTemplateSetParamsPayload,
    TWizardOrderTemplateSetStepValidAction,
} from './types';

/*
 * -------------------------------------------
 *         Common Wizard Actions
 * -------------------------------------------
 */

export const wizardOrderTemplateHandleNextAction = (): TWizardOrderTemplateHandleNextAction =>
    createAction(WIZARD_ORDER_TEMPLATE_HANDLE_NEXT);


export const wizardMultiSearchSetStepValidAction = (
    payload: IWizardOrderTemplateSetStepValidPayload,
): TWizardOrderTemplateSetStepValidAction => createAction(WIZARD_ORDER_TEMPLATE_SET_STEP_VALID, payload);


export const wizardOrderTemplateSetParamsAction = (payload: TWizardOrderTemplateSetParamsPayload)
    : TWizardOrderTemplateDataSetParamsAction =>
    createAction(WIZARD_ORDER_TEMPLATE_SET_PARAMS, payload);
